import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LinearProgress as MuiLinearProgress } from '@material-ui/core';

/**
 * LinearProgress를 사용하여 사용자에게 작업의 진행 정도를 나타낼 수 있습니다.
 *
 * @version 1.0.0
 * @author [parkwookyun](https://github.com/parkwookyun)
*/

const LinearProgress = styled(({
  marginright,
  height,
  width,
  barColor,
  ...otherProps
}) => (
  <MuiLinearProgress
    classes={{
      barColorPrimary: 'barColorPrimary',
    }}
    {...otherProps}
  />
))`
&& {
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  margin-right: ${({ marginright }) => marginright};
  display: inline-flex;
  background: #eceff1;
  border-radius: 8px;

}
.barColorPrimary {
  border-radius: 8px;
  background: ${({ barcolor }) => barcolor};
}
`;

LinearProgress.propTypes = {
  /** 진행 정도를 나타내는 수치. 0 ~ 100 사이의 값을 가질 수 있습니다. */
  value: PropTypes.number.isRequired,
  /** 변형 타입 */
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'buffer', 'query']),
};

LinearProgress.defaultProps = {
  variant: 'indeterminate',
};

/** @component */
export default LinearProgress;
